var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('QuestionList',{ref:"questionList",attrs:{"title":_vm.title,"items":_vm.listQuestions,"search":_vm.search,"pagination":_vm.pagination,"dialogs":_vm.dialogs,"suffix":_vm.suffix,"replaceRoute":_vm.replaceRoute},on:{"loadQuestions":_vm.loadQuestions,"deleteConfirm":_vm.deleteConfirm,"addDialogActivate":_vm.addDialogActivate}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10667902","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/questions/test/Index.vue
// module id = null
// module chunks = 